import { Typography, Link } from '@mui/material';

export const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      Copyright &copy; <Link color="inherit" href="https://load1.com/">Load One LLC</Link> {new Date().getFullYear()}.
    </Typography>
  );
}